import { postFilterSet } from '../../store/saved-filters-api';
import {
  collectionOptionFormTypes,
  dateOptionFormTypes,
  numericOptionFormTypes,
  stringOptionFormTypes,
} from '../../services/filtering/filter-form-render-service/option-form-types';
import { normalizeCollectionFilters } from '../../services/filtering/collection-filter-mapping-service';
import {
  mapCollectionFilterToApiFilters,
  mapDateTimeFilterToApiFilters,
  mapNumericFilterToApiFilters,
  mapStringFilterToApiFilters,
} from './filter-mapping/generic-filter-mappers';
import { specialFilterMappers } from './filter-mapping/special-filter-mappers';

export const buildAppliedFiltersPayload = (appliedFilters) => {
  const appliedFiltersPayload = appliedFilters.reduce(
    (acc, appliedFilter) => {
      const specialFilterMapper = specialFilterMappers[appliedFilter.filterById];
      if (specialFilterMapper) {
        const {
          stringFilters,
          numericFilters,
          dateTimeFilters,
          normalizableCollectionFilters,
          unnormalizableCollectionFilters,
          booleanFilters,
        } = specialFilterMapper(appliedFilter);

        return {
          stringFilters: [...acc.stringFilters, ...(stringFilters || [])],
          numericFilters: [...acc.numericFilters, ...(numericFilters || [])],
          dateTimeFilters: [...acc.dateTimeFilters, ...(dateTimeFilters || [])],
          normalizableCollectionFilters: [...acc.normalizableCollectionFilters, ...(normalizableCollectionFilters || [])],
          unnormalizableCollectionFilters: [...acc.unnormalizableCollectionFilters, ...(unnormalizableCollectionFilters || [])],
          booleanFilters: [...acc.booleanFilters, ...(booleanFilters || [])],
        };
      }

      if (stringOptionFormTypes.has(appliedFilter.type)) {
        acc.stringFilters.push(...mapStringFilterToApiFilters(appliedFilter));
      } else if (numericOptionFormTypes.has(appliedFilter.type)) {
        acc.numericFilters.push(...mapNumericFilterToApiFilters(appliedFilter));
      } else if (dateOptionFormTypes.has(appliedFilter.type)) {
        acc.dateTimeFilters.push(...mapDateTimeFilterToApiFilters(appliedFilter));
      } else if (collectionOptionFormTypes.has(appliedFilter.type)) {
        acc.normalizableCollectionFilters.push(...mapCollectionFilterToApiFilters(appliedFilter));
      }

      return acc;
    },
    {
      stringFilters: [],
      numericFilters: [],
      dateTimeFilters: [],
      normalizableCollectionFilters: [],
      unnormalizableCollectionFilters: [],
      booleanFilters: [],
    },
  );

  return {
    stringFilters: appliedFiltersPayload.stringFilters,
    numericFilters: appliedFiltersPayload.numericFilters,
    dateTimeFilters: appliedFiltersPayload.dateTimeFilters,
    collectionFilters: [
      ...normalizeCollectionFilters(appliedFiltersPayload.normalizableCollectionFilters),
      ...appliedFiltersPayload.unnormalizableCollectionFilters,
    ],
    booleanFilters: appliedFiltersPayload.booleanFilters,
  };
};

const saveFilterSet = (name, appliedFilters, active = true) => {
  const requestPayload = {
    name,
    appliedFilters: buildAppliedFiltersPayload(appliedFilters),
    active,
  };
  return postFilterSet(requestPayload);
};

export default saveFilterSet;
